<template>
<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	width="24" height="24"
	viewBox="0 0 171 171"
	>
	<path d="M0,171.99654v-171.99654h171.99654v171.99654z" fill="none"></path>
	<path d="M85.5,14.25c-39.28701,0 -71.25,31.96301 -71.25,71.25c0,39.28699 31.96299,71.25 71.25,71.25c39.28701,0 71.25,-31.96301 71.25,-71.25c0,-39.28699 -31.96299,-71.25 -71.25,-71.25zM85.5,24.9375c14.81981,0 28.19523,5.49862 38.7074,14.29871l-84.97119,84.96423c-8.79801,-10.5116 -14.29871,-23.88258 -14.29871,-38.70044c0,-33.51104 27.05143,-60.5625 60.5625,-60.5625zM131.76379,46.7926c8.80008,10.51218 14.29871,23.8876 14.29871,38.7074c0,33.51104 -27.05143,60.5625 -60.5625,60.5625c-14.81787,0 -28.18885,-5.50069 -38.70044,-14.29871z">
	</path>
</svg>
</template>
<script>
export default {
    name: 'icon-forbid',
};
</script>
<style>

</style>
